const BNBChain = ({ ...props }) => {
  return (
    <svg
      width="311"
      height="55"
      viewBox="0 0 311 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.103 8.49478L23.5826 0.137085L38.0622 8.49478L32.7387 11.5823L23.5826 6.3122L14.4264 11.5823L9.103 8.49478ZM38.0622 19.035L32.7387 15.9475L23.5826 21.2176L14.4264 15.9475L9.103 19.035V25.2102L18.2592 30.4802V41.0205L23.5826 44.1082L28.906 41.0205V30.4802L38.0622 25.2102V19.035ZM38.0622 35.7505V29.5753L32.7387 32.6628V38.8379L38.0622 35.7505ZM41.8417 37.933L32.6855 43.2031V49.3782L47.1651 41.0205V24.3051L41.8417 27.3928V37.933ZM36.5185 13.7649L41.8417 16.8525V23.0276L47.1651 19.94V13.7649L41.8417 10.6774L36.5185 13.7649ZM18.2592 45.4391V51.6142L23.5826 54.7016L28.906 51.6142V45.4391L23.5826 48.5265L18.2592 45.4391ZM9.103 35.7505L14.4264 38.8379V32.6628L9.103 29.5753V35.7505ZM18.2592 13.7649L23.5826 16.8525L28.906 13.7649L23.5826 10.6774L18.2592 13.7649ZM5.32336 16.8525L10.6467 13.7649L5.32336 10.6774L0 13.7649V19.94L5.32336 23.0276V16.8525ZM5.32336 27.3928L0 24.3051V41.0205L14.4795 49.3782V43.2031L5.32336 37.933V27.3928Z"
        fill="#FFA686"
      />
      <path
        d="M89.133 34.3797V34.2931C89.133 30.2153 86.9641 28.1764 83.4501 26.8317C85.6193 25.6169 87.4413 23.7081 87.4413 20.281V20.1943C87.4413 15.4223 83.6238 12.3423 77.4203 12.3423H63.3213V42.709H77.7673C84.6215 42.709 89.133 39.9326 89.133 34.3797ZM80.804 21.4089C80.804 23.6646 78.9386 24.6191 75.9887 24.6191H69.8286V18.1987H76.4225C79.2423 18.1987 80.804 19.3266 80.804 21.3222V21.4089ZM82.4957 33.5556C82.4957 35.8114 80.7171 36.8527 77.7673 36.8527H69.8286V30.1719H77.5504C80.9775 30.1719 82.4957 31.4299 82.4957 33.4687V33.5556Z"
        fill="#FFA686"
      />
      <path
        d="M122.046 42.709V12.3423H115.452V31.0395L101.223 12.3423H95.0625V42.709H101.656V23.4045L116.363 42.709H122.046Z"
        fill="#FFA686"
      />
      <path
        d="M155.58 34.3797V34.2931C155.58 30.2153 153.411 28.1764 149.897 26.8317C152.066 25.6169 153.888 23.7081 153.888 20.281V20.1943C153.888 15.4223 150.071 12.3423 143.867 12.3423H129.769V42.709H144.214C151.069 42.709 155.58 39.9326 155.58 34.3797ZM147.251 21.4089C147.251 23.6646 145.386 24.6191 142.436 24.6191H136.276V18.1987H142.87C145.689 18.1987 147.251 19.3266 147.251 21.3222V21.4089ZM148.943 33.5556C148.943 35.8114 147.164 36.8527 144.214 36.8527H136.276V30.1719H143.997C147.425 30.1719 148.943 31.4299 148.943 33.4687V33.5556Z"
        fill="#FFA686"
      />
      <path
        d="M195.845 37.3447L192.418 33.8742C189.815 36.3034 187.429 37.8219 183.698 37.8219C177.885 37.8219 173.677 32.9632 173.677 26.9765C173.677 20.99 177.885 16.2181 183.698 16.2181C187.169 16.2181 189.772 17.7364 192.201 19.9923L195.628 16.0446C192.721 13.2682 189.338 11.316 183.742 11.316C174.545 11.316 168.081 18.3872 168.081 27.0634C168.081 35.8262 174.675 42.7239 183.525 42.7239C189.208 42.7239 192.678 40.6416 195.845 37.3447Z"
        fill="#FFA686"
      />
      <path
        d="M221.711 29.406V42.2034H227.047V11.8365H221.711V24.4604H207.222V11.8365H201.886V42.2034H207.222V29.406H221.711Z"
        fill="#FFA686"
      />
      <path
        d="M250.983 11.6195H246.038L232.677 42.2033H238.142L241.266 34.8718H255.626L258.706 42.2033H264.345L250.983 11.6195ZM253.673 30.1431H243.219L248.423 17.9965L253.673 30.1431Z"
        fill="#FFA686"
      />
      <path
        d="M270.289 11.8365V42.2034H275.625V11.8365H270.289Z"
        fill="#FFA686"
      />
      <path
        d="M305.402 32.8331L289.132 11.8365H284.188V42.2034H289.437V20.5995L306.182 42.2034H310.651V11.8365H305.402V32.8331Z"
        fill="#FFA686"
      />
    </svg>
  );
};

export default BNBChain;
